<template>
  <div class="row">
    <div class="col-12">
      <PageHeader
        :page="page"
        :has-save="!isSaved"
        :has-return="true"
        @onSave="onSave"
        :save-disabled="saee12Required"
        @onReturn="goToHistorialEgreso"
      />
      <div class="row mb-4" v-if="saee12Required">
        <div class="col-12 mx-3">
          <custom-status-link
            :title="
              'Se ha identificado que el estudiante es Elegible para la SAEE-12, favor de completar y someter antes de continuar con el Egreso.'
            "
            :status="'Pendiente'"
            :use-link-event="false"
            @enter="createSaee12()"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <SectionTitle :content="title" :has-line="true" />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <ValidationObserver ref="formAddEvaluation" v-slot="{}" tag="form">
            <div class="row pl-3 pr-1">
              <div class="col-3 col-sm col-12 py-0">
                <span>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="date"
                    rules="required"
                  >
                    <custom-date-picker
                      v-model="model.date"
                      label="Fecha de Egreso"
                      format="dd/MMM./yyyy"
                      :max-date="isEditing ? null : maxDate"
                      :class-container="'w-100'"
                      :custom-error-msg="'Favor seleccionar fecha de egreso'"
                      :error="errors[0]"
                      :disabled="egressDateDisabled"
                      @onSelectedDate="onSelectedDate"
                    />
                  </ValidationProvider>
                </span>
              </div>
              <div class="col-5 col-sm col-12 py-0 mt-2 mt-md-0 mt-sm-2">
                <span>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="reason"
                    rules="required"
                  >
                    <custom-drop-down
                      v-model="selectedReason"
                      label="Razón:"
                      :options="reasons"
                      placeholder="Seleccione"
                      required
                      :fieldkey="'id'"
                      :fieldname="'name'"
                      :disabled="readonly"
                      class=""
                      :error="errors[0]"
                      :custom-error-msg="'Favor seleccionar razón de egreso'"
                      @input="onReasonChange($event)"
                    />
                  </ValidationProvider>
                </span>
              </div>
              <div class="col-4 col-sm col-12 py-0 pt-2">
                <div class="font-weight-bold">
                  Año Académico:
                </div>
                <div class="pt-2 font-weight-normal">
                  {{ currentYear.description }}
                </div>
              </div>
            </div>

            <div
              v-if="model != null && model.date != undefined"
              class="row pl-3 pr-1 py-2"
            >
              <div class="col-3 col-sm col-12">
                <div v-if="currentSchool.regionId">
                  <div class="font-weight-bold">
                    Región:
                  </div>
                  <div class="font-weight-normal">
                    {{ currentSchool.regionName }}
                  </div>
                </div>
                <div v-if="!currentSchool.regionId">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="region"
                    rules="required"
                  >
                    <custom-drop-down
                      v-model="selectedRegion"
                      :options="regions"
                      placeholder="Seleccione"
                      required
                      fieldkey="id"
                      fieldname="name"
                      :disabled="readonly"
                      label="Región:"
                      class="w-100"
                      :error="errors[0]"
                      :custom-error-msg="messages.fieldRequired"
                      @input="onRegionChange($event)"
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-5 col-sm col-12 mt-2 mt-md-0 mt-sm-2">
                <div v-if="currentSchool.districtId">
                  <div class="font-weight-bold">
                    Distrito:
                  </div>
                  <div class="font-weight-normal">
                    {{ currentSchool.districtName }}
                  </div>
                </div>
                <div v-if="!currentSchool.districtId">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="district"
                    rules="required"
                  >
                    <custom-drop-down
                      v-model="selectedDistrict"
                      :options="districts"
                      placeholder="Seleccione"
                      required
                      :fieldkey="'id'"
                      :fieldname="'name'"
                      :disabled="readonly"
                      label="Distrito:"
                      class=""
                      :error="errors[0]"
                      :custom-error-msg="messages.fieldRequired"
                      @input="onDistrictChange($event)"
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-4 col-sm col-12 mt-2 mt-md-0 mt-sm-2">
                <div v-if="currentSchool.schoolId">
                  <div class="font-weight-bold">
                    Escuela:
                  </div>
                  <div class="font-weight-normal">
                    {{ currentSchool.schoolName }}
                  </div>
                </div>
                <div v-if="!currentSchool.schoolId">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="school"
                    rules="required"
                  >
                    <custom-drop-down
                      v-model="selectedSchool"
                      :options="schools"
                      placeholder="Seleccione"
                      required
                      :fieldkey="'id'"
                      :fieldname="'name'"
                      :disabled="readonly"
                      label="Escuela:"
                      class="w-75"
                      :error="errors[0]"
                      :custom-error-msg="messages.fieldRequired"
                      @input="onSchoolChange($event)"
                    />
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="col-12 mt-4 pl-3 pr-0">
              <span>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="comment"
                  rules="required"
                >
                  <custom-text-area
                    v-model="model.comment"
                    label="Comentario:"
                    :maxlength="500"
                    :disabled="readonly"
                    :error="errors[0]"
                    :custom-error-msg="'Favor registrar comentario'"
                  />
                </ValidationProvider>
              </span>
            </div>
            <div
              v-if="
                (reasonChangeComment && reasonChangeComment.length > 0) ||
                  (reasonChanged && (isSaved || isEditing))
              "
              class="col-12 mt-4 pl-3 pr-0"
            >
              <span>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="comment"
                  rules="required"
                >
                  <custom-text-area
                    v-model="model.reasonChangeComment"
                    label="Describa Brevemente la Razón del Cambio:"
                    :maxlength="3000"
                    :disabled="readonly"
                    :error="errors[0]"
                    :custom-error-msg="'Favor registrar razón del cambio'"
                  />
                </ValidationProvider>
              </span>
            </div>
            <div class="row">
              <div v-if="isSaved || isEditing" class="col-12 mt-4">
                <SectionTitle
                  content="Creación y Modificación"
                  :has-line="true"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-12 d-flex">
                <div v-if="createByFullName" class="col-4">
                  <div class="font-weight-bold">
                    Creación:
                  </div>
                  <div class="font-weight-normal">
                    {{ createByFullName }}
                    <br />
                    {{ createDate }}
                    <br />
                    {{ createTime }}
                  </div>
                </div>
                <div v-if="modifyByFullName" class="col-4">
                  <div class="font-weight-bold">
                    Modificación:
                  </div>
                  <div class="font-weight-normal">
                    {{ modifyByFullName }}
                    <br />
                    {{ modifyDate | date }}
                    <br />
                    {{ modifyTime | date }}
                  </div>
                </div>
              </div>
            </div>
          </ValidationObserver>
        </div>
      </div>

      <div class="row mt-4">
        <div v-if="this.additionalQuestionsFlag" class="col-12">
          <additional-questions
            ref="additionalQuestions"
            :academic-year="currentYear"
            :exitid="Number(exitId)"
            class="mb-4"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdditionalQuestions from '.././components/AdditionalQuestions';
import SectionTitle from '@/components/pei/shared/SectionTitle';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from '@/components/common/CustomTextArea';
import CustomStatusLink from '@/components/common/CustomStatusLink';

import { ValidationProvider, ValidationObserver } from 'vee-validate';
import store from '@/store/index';
import mixWait from '@/mixin/loading.mixin';
import mixAlert from '@/mixin/alert.mixin';
import moment from 'moment';
import PageHeader from '@/components/common/page/PageHeader';
import StudentStatuses from '@/utils/constants/reg/studentStatuses.js';
import EduEspCode from '@/utils/constants/eduEspCode';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import academicYearService from '@/services/academicyear';
import transitionStudentService from '@/services/pei/transitionStudent.js';
import peiTransitionStudentStatus from '@/utils/constants/pei/peiTransitionStudentStatus.js';
import storeMixin from '@/mixin/storeGenerator';

const TRANSITION_STUDENT_ROUTE_NAME = 'transition-student-saee-12';

export default {
  name: 'AddEditEgress',
  mixins: [mixWait, mixAlert, storeMixin],
  components: {
    SectionTitle,
    CustomDatePicker,
    CustomDropDown,
    CustomTextArea,
    ValidationProvider,
    ValidationObserver,
    PageHeader,
    AdditionalQuestions,
    CustomStatusLink,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-circle',
        title: 'Añadir Egreso',
        routes: [
          'Inicio',
          'Estudiante',
          'Egreso',
          'Egreso: Historial del Estudiante / Añadir',
        ],
      },
      currentAcademiYearId: null,
      title: 'Información General',
      sysParameters: { LastSchoolDate: {}, MajorityAge: {} },
      selectedReason: null,
      originalSelectedReasonId: null,
      selectedRegion: null,
      selectedDistrict: null,
      selectedSchool: null,
      readonly: false,
      isSaved: false,
      maxDate: new Date(),
      validationMessages: [],
      studentSie: store.getters['$_student/StudentSie'],
      studentAge: null,
      saee12ForEgress: null,
      currentYear: {
        id: null,
        description: null,
        year: null,
      },
      createByFullName: null,
      createDate: null,
      createTime: null,
      modifyByFullName: null,
      modifyDate: null,
      modifyTime: null,
      reasonChangeComment: null,
      currentSchool: {
        regionId: null,
        regionName: null,
        districtId: null,
        districtName: null,
        schoolId: null,
        schoolName: null,
      },
      model: {
        studentExitId: null,
        reasonId: null,
        regionId: null,
        districtId: null,
        schoolId: null,
        comment: null,
        reasonChangeComment: null,
        date: null,
        studentSieId: null,
        academicYearId: null,
      },
      messages: {
        fieldRequired: 'Campo requerido.',
      },
      isEditing: false,
      reasonChanged: false,
      reasons: [],
      regions: [],
      districts: [],
      schools: [],
    };
  },
  methods: {
    onSelectedDate(date) {
      if (date) {
        this.$ApiGet('/api/academicyears/getacademicyearfordate', {
          date: date,
        }).then((response) => {
          const yearChanged = response.data?.id != this.currentYear?.id;
          this.currentYear = response.data;
          this.loadStudentSchool();
          yearChanged && this.loadStudentAgeByAcademicYear();
        });
      }
    },
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
    formatTime(date) {
      return moment(date)
        .locale('es')
        .format('hh:mm:ss a');
    },
    goToHistorialEgreso() {
      this.$router.push({ path: '/student/egress/historyegress' });
    },
    async loadSysParam() {
      const { data: lastSchoolDate } = await getSysparameterByNames({
        academicYearId: this.currentAcademicYear().id,
        parameterNames: ['LastSchoolDate'],
      });
      const { data } = await getSysparameterByNames({
        parameterNames: ['MajorityAge', 'ActivateCreateSaee12'],
      });

      this.sysParameters = [...lastSchoolDate, ...data].reduce(
        (acc, current) => ({ ...acc, [current.name]: current }),
        this.sysParameters
      );
    },
    loadStudentAgeByAcademicYear() {
      /*
        Let's only load the age when neccessary:
         if not being previusly loaded
         if current year is selected
         if selected reason is ReachedMaximumAge
      */
      if (
        !this.studentAge &&
        this.currentYear &&
        this.model.reasonId == EduEspCode.ReachedMaximumAge
      ) {
        this.$ApiGet('/api/student/getstudentageinacademicyeardateto', {
          studentSie: this.studentSie,
          academicYearId: this.currentYear.id,
        }).then(({ data }) => {
          this.studentAge = data;
        });
      }
    },
    loadStudentSchool() {
      this.$ApiGet(
        `api/student/egress/getstudentschool?studentSie=${
          this.studentSie
        }&egressDate=${this.formatDate(this.model.date)}`
      ).then((response) => {
        this.currentSchool = response.data;
        this.selectedRegion = {
          id: this.currentSchool.regionId,
          name: this.currentSchool.regionName,
        };
        this.selectedDistrict = {
          id: this.currentSchool.districtId,
          name: this.currentSchool.districtName,
        };
        this.selectedSchool = {
          id: this.currentSchool.schoolId,
          name: this.currentSchool.schoolName,
        };

        if (this.selectedSchool.id == null || this.selectedSchool.id == 0) {
          this.selectedRegion = null;
          this.selectedDistrict = null;
          this.selectedSchool = null;

          this.districts = [];
          this.schools = [];
        }
        this.loadRegion();
      });
    },
    loadExitReason() {
      this.$ApiGet(`api/code/getcodebytype?type=EduEspExiting`).then(
        (response) => {
          this.reasons = response.data;
        }
      );
    },
    loadRegion() {
      this.$ApiGet(
        `api/schools/types/regions?academicyear=${this.currentYear.id}`
      ).then((response) => {
        this.regions = response.data;

        if (this.model.regionId) {
          this.selectedRegion = this.regions.find(
            (x) => x.id == this.model.regionId
          );
          if (this.selectedRegion) {
            this.loadDistrict(this.selectedRegion.id);
          }
        }
      });
    },
    loadDistrict(regionId) {
      this.$ApiGet(
        `api/schools/types/regions/districts?regionid=${regionId}&academicyear=${this.currentYear.id}`
      ).then((response) => {
        this.districts = response.data;
        this.selectedDistrict = this.districts.find(
          (x) => x.id == this.model.districtId
        );

        if (this.selectedDistrict) {
          this.loadSchool(this.selectedDistrict.id);
        }
      });
    },
    loadSchool(districtId) {
      this.$ApiGet(
        `api/schools?districtid=${districtId}&academicyear=${this.currentYear.id}`
      ).then((response) => {
        this.schools = response.data;
        this.selectedSchool = this.schools.find(
          (x) => x.id == this.model.schoolId
        );
      });
    },
    onRegionChange(item) {
      this.model.regionId = item ? item.id : null;
      (this.selectedDistrict = null),
        (this.selectedSchool = null),
        this.loadDistrict(this.model.regionId);
    },
    onDistrictChange(item) {
      this.model.districtId = item ? item.id : null;
      (this.selectedSchool = null), this.loadSchool(this.model.districtId);
    },
    onSchoolChange(item) {
      this.model.schoolId = item ? item.id : null;
    },
    async onReasonChange(item) {
      if (!this.model.date) {
        this.ShowToast(
          'Alerta',
          'La fecha de egreso debe ser seleccionada.',
          'error'
        );
        this.selectedReason = {
          name: '',
          id: null,
        };
        return;
      }
      this.model.reasonId = item ? item.id : null;

      if (
        this.originalSelectedReasonId &&
        this.model.reasonId != this.originalSelectedReasonId
      ) {
        this.reasonChanged = true;
      } else {
        this.reasonChanged = false;
      }

      if (this.isEgressDateLastSchoolDate) {
        let dateSelected = this.model.date;
        let lastDateOfAcademicYear = moment(
          this.sysParameters.LastSchoolDate.staticValue
        ).toDate();
        this.onSelectedDate(dateSelected);
        if (this.currentYear.id != this.currentAcademiYearId) {
          this.model.date = dateSelected;
          return;
        }
        this.model.date = lastDateOfAcademicYear;
      }

      this.loadStudentAgeByAcademicYear();
    },
    async onSave() {
      if (
        this.model.reasonId == EduEspCode.ReachedMaximumAge &&
        !this.isStudentInLegalAge
      ) {
        this.ShowToast(
          'Alerta',
          'El estudiante no cumple con la mayoría de edad.',
          'error'
        );

        return;
      }
      const isValid = await this.$refs.formAddEvaluation.validate();
      var isAQValid =
        !this.additionalQuestionsFlag || this.$refs.additionalQuestions.isValid;

      if (!isValid || !isAQValid) {
        this.ShowToast(
          'Alerta',
          'Favor de completar los campos requeridos.',
          'error'
        );
        return;
      }

      /*Se deben cancelar los PEIs que el estudiante tenga en borrador*/
      await this.$ApiPut(
        `api/student/cancelPeifromDraft/${this.studentSie}`
      ).then(async () => {
        this.model.studentSieId = +this.studentSie;
        this.model.schoolId = this.selectedSchool.id;
        this.model.regionId = this.selectedRegion.id;
        this.model.districtId = this.selectedDistrict.id;
        this.model.academicYearId = this.currentYear.id;

        if (this.additionalQuestionsFlag) {
          this.$refs.additionalQuestions.mapQuestionsAnswers();
          this.model.StudentExitAdditionalQuestions = this.$refs.additionalQuestions.PeiAdditionalQuestionsToDB;
        }

        this.$ApiPost('api/student/egresshistory', this.model)
          .then((response) => {
            this.ShowToast(
              'Proceso exitoso.',
              this.getMessage('0636').name,
              'success'
            );
            if (!this.isEditing) {
              store.dispatch('$_student/refreshStudentMainInfo');
            }
            this.createByFullName = response.data.createByFullName;
            this.createDate = this.formatDate(response.data.createDate);
            this.createTime = this.formatTime(response.data.createDate);
            this.modifyByFullName = response.data.modifyByFullName;
            this.modifyDate = response.data.modifyDate;
            this.modifyTime = response.data.modifyDate;
            this.readonly = true;
            this.isSaved = true;

            this.persistLazyData({ ...this._data }); // persists the data
          })
          .catch((err) => {
            this.ShowToast(err.response.data.message, '', 'error');
            this.response = err;
          });
      });
    },
    validationMessagesByCode() {
      const promise = this.$ApiGet(
        '/api/validationsmessages?messageCodes=0636'
      );
      promise.then((res) => {
        this.validationMessages = res.data;
      });
    },
    getMessage(code) {
      return this.validationMessages.find((element) => element.id == code);
    },
    getEgress(id) {
      this.$ApiGet(`api/student/egresshistory/${id}`).then((response) => {
        const data = response.data;
        this.model = data;
        this.model.date = new Date(data.date);
        this.selectedReason = { id: data.reasonId, name: data.reason };
        this.originalSelectedReasonId = data.reasonId;
        this.createByFullName = data.createByFullName;
        this.createDate = this.formatDate(data.createDate);
        this.createTime = this.formatTime(data.createDate);
        this.modifyByFullName = data.modifyByFullName;
        this.modifyDate = this.formatDate(data.modifyDate);
        this.modifyTime = this.formatTime(data.modifyDate);
        this.reasonChangeComment = data.reasonChangeComment;
        this.onSelectedDate(this.model.date);
        this.model.regionId = data.region.id;
        this.model.districtId = data.district.id;
        this.model.schoolId = data.school.id;
      });
    },
    async init() {
      if (this.$route.query.id) {
        this.getEgress(this.$route.query.id);
        this.title = 'Editar egreso estudiante';
        this.page.title = 'Editar Egreso';
        this.page.routes = [
          'Inicio',
          'Estudiante',
          'Egreso',
          'Egreso: Historial del Estudiante / Editar',
        ];
        this.isEditing = true;
      }
      const {
        data: current,
      } = await academicYearService.getCurrentAcademicYear();
      this.currentAcademiYearId = current.id;
      await this.getSaee12ForEgress();
    },
    async getSaee12ForEgress() {
      const { data } = await transitionStudentService.getSaee12ForEgress(
        this.studentSie
      );

      this.saee12ForEgress = data;
    },
    async createSaee12() {
      let id = this.saee12ForEgress?.id;
      if (!id) {
        const { data } = await transitionStudentService
          .saveStudentSAEE12(this.studentSie)
          .catch((error) => {
            this.ShowToast('Alerta', error.response.data.message, 'error');
          });

        id = data;
      }

      this.$router.push({
        name: TRANSITION_STUDENT_ROUTE_NAME,
        params: { id: id, isFromEgress: true },
      });
    },
  },
  computed: {
    additionalQuestionsFlag() {
      return this.currentYear.id != null;
    },
    saee12Required() {
      const validReasons = [
        EduEspCode.ReachedMaximumAge,
        EduEspCode.GraduatedWithHighSchoolDiploma,
        EduEspCode.ReceivedModifiedCertificationOrDiploma,
      ];

      return (
        validReasons.includes(this.selectedReason?.id) &&
        this.saee12ForEgress?.isValid &&
        !this.isPrivateStudent &&
        this.isStudenElegible &&
        this.sysParameters.ActivateCreateSaee12.staticValue.toLowerCase() ===
          'true'
      );
    },
    isPrivateStudent() {
      return this.$store.getters.SelectedStudent.studentType === 'Privado'
        ? true
        : false;
    },
    exitId() {
      return this.$route.query.id;
    },
    isEgressDateLastSchoolDate() {
      return [
        EduEspCode.GraduatedWithHighSchoolDiploma,
        EduEspCode.ReceivedModifiedCertificationOrDiploma,
      ].includes(this.model.reasonId);
    },
    isStudentInLegalAge() {
      const majorityAge = parseInt(this.sysParameters.MajorityAge.staticValue);
      return this.studentAge >= majorityAge;
    },
    isStudenElegible() {
      let studentStatus = this.$store.state.$_student.selectedStudent.status;
      if (studentStatus != null) {
        switch (studentStatus) {
          case StudentStatuses.Servido:
            return true;
          case StudentStatuses.Elegible:
            return true;
          default:
            return false;
        }
      } else {
        return false;
      }
    },
    egressDateDisabled() {
      return this.userHasPermissions('student.egress.edit.date')
        ? false
        : this.readonly || this.isEgressDateLastSchoolDate;
    },
  },
  beforeMount() {
    let persistedData = this.$store?.state?.moduleGenerated?.data ?? {};
    const selectedStudentSie = store.getters['$_student/StudentSie'];
    const hasPersistedData =
      Object.keys(persistedData).length > 0 &&
      persistedData.model?.studentSieId > 0;
    if (
      hasPersistedData &&
      persistedData?.model?.studentSieId == selectedStudentSie
    ) {
      this._data = persistedData;
    } else if (
      hasPersistedData &&
      persistedData?.model?.studentSieId != selectedStudentSie
    ) {
      this.persistLazyData({}); // Clear the data
      this.clearData(); // Clear the data
    }
  },
  async mounted() {
    this.validationMessagesByCode();
    this.loadExitReason();
    this.loadSysParam();
    this.init();
  },
};
</script>

<style scoped>
.egreso-container {
  font-weight: 400;
}
</style>
